import Vue from 'vue'
import ComHeader from './comHeader' // 头部
import ComFooter from './comFooter' // 底部
import ComAside from './comAside' // 侧边导航栏

Vue.component('com-header', ComHeader)
Vue.component('com-footer', ComFooter)
Vue.component('com-aside', ComAside)



// WEBPACK FOOTER //
// ./src/components/index.js